<template>
  <div class="container">
    <div class="header">
      <div class="" style="height: var(--status-bar-height);"></div>
      <div class="nav">
        <img src="../assets/img/white-back.png" alt="" class="back" />
      </div>
    </div>
    <div class="top-h"></div>
    <img src="../assets/img/help-1.png" alt="" class="photo_1" />
    <img src="../assets/img/step.png" alt="" class="photo_2" />
    <div class="middle-block">
      <div class="block-title">
        <img src="../assets/img/some.png" alt="" class="photo_3" />
        <div class="the-txt">
          邀请砍价
        </div>
        <img src="../assets/img/some.png" alt="" class="photo_3" />
      </div>
      <!-- <div class="section2">
				<div class="s-left">
					<div class="s-l-count">
						<span>0</span>/5 人
					</div>
					<div class="s-l-word">成功邀请</div>
				</div>
				<div class="s-left">
					<div class="s-l-count">
						<span>0</span>/100 元
					</div>
					<div class="s-l-word">已砍金额</div>
				</div>
			</div> -->
      <div class="section3 fl-center-al">
        剩余
        <div class="s-rest">
          <span>{{ formattedHours }}</span
          >&nbsp;:&nbsp; <span>{{ formattedMinutes }}</span
          >&nbsp;:&nbsp;
          <span>{{ formattedSeconds }}</span>
        </div>
        结束
      </div>
      <div
        class="the-btn fl-center-al"
        @click="toLink"
        :style="{ background: jieshu ? '#eee' : '' }"
      >
        前往APP助力
      </div>
    </div>
    <img src="../assets/img/xiamian.png" alt="" class="photo_4" />
  </div>
</template>

<script>
let myId;
function throttle(func, delay) {
  let lastTime = 0;

  return function() {
    const context = this;
    const args = arguments;
    const now = Date.now();

    if (now - lastTime >= delay) {
      func.apply(context, args);
      lastTime = now;
    }
  };
}
// 添加一个事件监听器来处理用户确认
document.addEventListener("visibilitychange", () => {
  if (document.visibilityState === "visible") {
    appOpened = true; // 如果页面变为可见，说明用户已确认打开应用
  }
});
let appOpened = false; // 状态变量，标记是否已尝试打开应用
const throttledToLink = throttle(function() {
  console.log(1);
  // 尝试打开 App
  const userAgent = navigator.userAgent.toLowerCase();
  if (userAgent.includes("micromessenger")) {
    alert("请在手机浏览器中打开链接");
    return false;
  }
  window.location.href = `xiagubargain://example?id=${myId}`;
  setTimeout(() => {
    if (!appOpened) {
      alert("请先下载APP");
    }
  }, 2000);
  let downloadLink = "https://www.pgyer.com/qv7uNdrO"; // 默认 Android 链接
  if (userAgent.includes("iphone") || userAgent.includes("ipad")) {
    downloadLink = "https://www.pgyer.com/giZTr84K"; // iOS 链接
  }
  setTimeout(() => {
    if (!appOpened) {
      window.location = downloadLink; // Android
    }
    // window.location = 'https://apps.apple.com/app/idYOUR_APP_ID'; // iOS
  }, 3000); // 2秒后重定向到下载页面
}, 3000); // 设定节流时间间隔为3000毫秒（3秒）
export default {
  name: "mainContent",
  props: {
    msg: String,
  },
  data() {
    return {
      remainingTime: 0, // 剩余时间（秒）
      interval: null,
      endTimestamp: 1730368800,
      jieshu: false,
    };
  },
  computed: {
    formattedHours() {
      return String(Math.floor(this.remainingTime / 3600)).padStart(2, "0");
    },
    formattedMinutes() {
      return String(Math.floor((this.remainingTime % 3600) / 60)).padStart(
        2,
        "0"
      );
    },
    formattedSeconds() {
      return String(this.remainingTime % 60).padStart(2, "0");
    },
  },
  mounted() {
    // 本地
    // const urlParams = new URLSearchParams(window.location.search);
    // const id = urlParams.get('id');
    // const timestamp = urlParams.get('timestamp');
    // myId = id
    // 有index.html#/
    const hash = window.location.hash;
    // 创建一个 URLSearchParams 实例，传入哈希部分去掉开头的 '#/'
    const urlParams = new URLSearchParams(hash.slice(2));

    const id = urlParams.get("id");
    const timestamp = urlParams.get("timestamp");
    myId = id;
    console.log(urlParams);
    console.log("ID:", id);
    console.log("Timestamp:", timestamp);
    this.endTimestamp = Math.floor(timestamp);
    console.log(this.endTimestamp);
    this.updateRemainingTime(); // 初始化剩余时间
    this.interval = setInterval(this.updateRemainingTime, 1000); // 每秒更新一次
  },
  beforeDestroy() {
    clearInterval(this.interval); // 清理定时器
  },
  methods: {
    toLink() {
      if (this.jieshu) {
        alert("活动已结束");
        // return false
      }
      throttledToLink();
    },
    updateRemainingTime() {
      const currentTime = Math.floor(Date.now() / 1000); // 当前时间戳（秒）
      this.remainingTime = Math.max(this.endTimestamp - currentTime, 0); // 计算剩余时间
      if (this.remainingTime === 0) {
        this.jieshu = true;
        clearInterval(this.interval); // 停止倒计时
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
:root {
  --status-bar-height: env(safe-area-inset-top);
}
</style>
<style scoped lang="scss">
.fl-center-al {
  display: flex;
  align-items: center;
  justify-content: center;
}

.container {
  background: #ffefc6;
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-image: url("../assets/img/the-bg.png");
  background-size: 100% 35.1%;
  background-repeat: no-repeat;
  overflow: hidden;
}

.top-h {
  width: 100vw;
  height: calc(3.67rem + var(--status-bar-height));
}

.header {
  width: 100vw;
  height: calc(3.67rem + var(--status-bar-height));
  position: fixed;
  z-index: 9;
}

.nav {
  height: 3.67rem;
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: row;
}

.back {
  width: 2rem;
  height: 2rem;
  margin-left: 1.33rem;
}

img {
  display: block;
}

.photo_1 {
  width: 22.33rem;
  height: 4.58rem;
  margin: 0.75rem auto 0;
}

.photo_2 {
  width: 28.58rem;
  height: 2.17rem;
  margin: 1.5rem auto 0;
}

.middle-block {
  width: 29.25rem;
  min-height: 17.42rem;
  background: #ffffff;
  border-radius: 0.67rem 0.67rem 0.67rem 0.67rem;
  overflow: hidden;
  margin-top: 1rem;
}

.block-title {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 29.25rem;
  height: 3.33rem;
  background: linear-gradient(90deg, #ffc062 0%, #ff8d43 100%);
}

.the-txt {
  margin-left: 0.75rem;
  margin-right: 0.75rem;
  font-family: CKTKingKong, CKTKingKong;
  font-weight: bold;
  font-size: 1.33rem;
  color: #ffffff;
}

.photo_3 {
  width: 2.9rem;
  height: 1.06rem;
}

.section2 {
  display: flex;
  align-items: center;
  width: 100%;
  margin-top: 1.83rem;
  justify-content: center;
}

.s-left {
  color: #333;
  font-size: 1.67rem;
  width: 50%;
  font-weight: 600;
}

.s-l-count span {
  color: #f95152;
}

.s-l-word {
  margin-top: 1.58rem;
  font-family: Alibaba PuHuiTi 2, Alibaba PuHuiTi 20;
  font-weight: normal;
  font-size: 1.08rem;
  color: #864527;
}

.section3 {
  margin-top: 3.5rem;
  font-weight: normal;
  font-size: 1.17rem;
  color: #000000;
}

.s-rest {
  margin: 0 0.92rem;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fd3f3f;
  font-weight: 600;
  font-size: 1.4rem;
  span {
    background: #fd3f3f;
    border-radius: 0.5rem 0.5rem 0.5rem 0.5rem;
    font-size: 1.33rem;
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: 2rem;
    min-height: 2rem;
    color: #fff;
  }
  font-weight: bold;
}

.the-btn {
  width: 24.92rem;
  height: 4rem;
  background: #fd3f3f;
  border-radius: 2.17rem 2.17rem 2.17rem 2.17rem;
  font-weight: normal;
  font-size: 1.33rem;
  color: #ffffff;
  margin: 2.67rem auto 0;
  z-index: 8;
}

.photo_4 {
  width: 100%;
  height: 28.33rem;
  position: relative;
  top: -3.92rem;
  pointer-events: none;
}
</style>
